import React, { useEffect, useMemo, useState, useContext } from "react";
import Slider from "react-slick";
import { useStaticQuery, graphql } from "gatsby";

// Components //
import TitleSection from "../../molecules/title-section";
import MediaCard from '../../molecules/media-card/mediaCard';
import rawToReact from "../../../utils/rawToReact";

// Context //
import GlobalContext from "../../../contexts/globalContext";

// References //
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

// Styles //
import "./empresasRecommended.scss";

const EmpresasRecommended = (props: ReferenciaContenido) => {

    const dataBibliotecaE = useStaticQuery(graphql`
        query DATABIBLIOTECAE {
            contentfulSubcategorias(contentful_id: {eq: "375byUYeLcAQQ0m8BX1vLf"}) {
                referenciaSubcategorias {
                    slug
                    referenciaSubcategorias {
                        slug
                        referenciaInterna {
                            referenciaContenido {
                                contentful_id
                            }
                            referenciaCabecera {
                                migaDePan
                                referenciaMultimedia {
                                    audioUrl
                                    autor
                                    categoriaMultimedia
                                    contentful_id
                                    createdAt
                                    descripcion {
                                        raw
                                    }
                                    imagenPrincipal {
                                        gatsbyImageData(
                                            layout: CONSTRAINED
                                            outputPixelDensities: [0.5, 1, 2]
                                            breakpoints: [320, 768, 1024, 1440]
                                            placeholder: BLURRED
                                            sizes: "(max-width: 320px) 320px, (max-width: 768px) 768px, (max-width: 1024px) 1024px, 1440px"
                                        )
                                        description
                                    }
                                    nuevoContenido
                                    tematica
                                    textoIntroductorio
                                    tiempoLectura
                                    tituloBoton
                                    tituloMultimedia
                                    videoUrl
                                    video {
                                        file {
                                            url
                                            fileName
                                            contentType
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const [slider, setSlider] = useState<any>();
    const [sliderIndex, setSliderIndex] = useState<number>(0);
    const [showContent, setShowContent] = useState<boolean>(false);
    const Context = useContext(GlobalContext);

    function getListSubcategorias(array, key) {
        return array.flatMap(obj => {
            const subCategories = obj[key];
            const parentSlug = obj.slug;
            return subCategories.map(value => ({ ...value.referenciaInterna.referenciaCabecera.referenciaMultimedia, parentSlug, slug: value.slug }));
        });
    }

    const transformedData = useMemo(() => getListSubcategorias(dataBibliotecaE.contentfulSubcategorias.referenciaSubcategorias, 'referenciaSubcategorias'), [])

    const getLastTrend = (array) => {return array.map(obj => { return { ...obj, date: new Date(obj.createdAt) } }).sort((a:any, b: any) => b.date - a.date)};

    const CarouselGeneral = {
        customPaging: i => (
            <div className={`line line-${i}`}>──</div>
        ),
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        arrows: false,
        slidesToScroll: 3,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
        autoplaySpeed: 10000,
        variableWidth: true,
        beforeChange: (_: number, next: number) => {
            setSliderIndex(next);
        },
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    variableWidth: false,
                },
            },
            {
                breakpoint: 570,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                },
            },
        ],
    };

    const goToNext = () => {
        if (sliderIndex < slider.props.children.length - 1) {
            setSliderIndex(sliderIndex + 1);
            slider.slickNext();
        }
    };

    const goToBack = () => {
        if (sliderIndex > 0) {
            setSliderIndex(sliderIndex - 1);
            slider.slickPrev();
        }
    };

    const isActiveBack = () => sliderIndex > 0;
    const isActiveNext = () => sliderIndex < slider?.props.children.length - 1;

    useEffect(() => {
        if (Context?.gigyaContext?.gigyaAccount || props.filtroTematica == "podcastView")
            setShowContent(true);
        else {
            setShowContent(false);
        }
    }, [Context.gigyaContext.gigyaAccount]);

    return (
        <>
            {showContent ? (
                <div className="o-empresas-recommended">
                    <div className="container">
                        <div className="o-empresas-recommended__inner">
                            <TitleSection title={
                                props.filtroTematica == "podcastView"?
                                "También te puede interesar..." : "Recomendados para ti"
                                }/>
                            <div className="o-empresas-recommended__slider">
                                <div className="arrows-slider">
                                    <span
                                        className={`arrow icon-chevron-left ${isActiveBack() ? "active" : ""} gtm_navegar_atras_biblio_empresas`}
                                        onClick={goToBack}
                                    ></span>
                                    <span
                                        className={`arrow  icon-chevron-right  ${isActiveNext() ? "active" : ""} gtm_navegar_adelante_biblio_empresas`}
                                        onClick={goToNext}
                                    ></span>
                                </div>
                                <Slider
                                    ref={(c) => {
                                        setSlider(c);
                                    }}
                                    {...CarouselGeneral}
                                >
                                    {getLastTrend(transformedData).slice(0,6).map((item, i) => (
                                        <MediaCard 
                                            tituloMultimedia={item.tituloMultimedia}
                                            descripcion={item.descripcion}
                                            imagenPrincipal={item.imagenPrincipal}
                                            tituloBoton={item.tituloBoton}
                                            tematica={item.tematica}
                                            categoriaMultimedia={item.categoriaMultimedia}
                                            nuevoContenido={item.nuevoContenido}
                                            textoIntroductorio={item.textoIntroductorio}
                                            slug={`${item.parentSlug}${item.slug}`}
                                            parentContentfulId={item.parentContentfulId}
                                            createdAt={item.createdAt}
                                        />
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            ):(null)}
        </>
    )
}

export default EmpresasRecommended;